var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.375,
    stroke: "#61C395",
    strokeWidth: 1.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1698 13.4788C12.5394 12.7396 13.2949 12.2727 14.1213 12.2727H15.7881C16.6145 12.2727 17.37 12.7396 17.7395 13.4788L19.9214 17.8425C20.6467 19.2932 19.5918 21 17.9699 21H11.9395C10.3175 21 9.26262 19.2932 9.98797 17.8425L12.1698 13.4788Z",
    fill: "#61C395"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4531 10.8624C12.6577 11.0669 12.9352 11.1819 13.2245 11.1819H16.6844C16.9738 11.1819 17.2513 11.0669 17.4558 10.8624L18.387 9.93121C18.7306 9.58759 18.4872 9.00005 18.0013 9.00005H11.9077C11.4217 9.00005 11.1784 9.58759 11.522 9.93121L12.4531 10.8624Z",
    fill: "#61C395"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/Bag.5307f8aa4a5fdbe2d565080a16b16c09.svg";
export { ForwardRef as ReactComponent };